import { render, staticRenderFns } from "./RecuUI.vue?vue&type=template&id=7e37afbc&"
import script from "./RecuUI.vue?vue&type=script&lang=ts&"
export * from "./RecuUI.vue?vue&type=script&lang=ts&"
import style0 from "./RecuUI.vue?vue&type=style&index=0&id=7e37afbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports